import m from "mithril";

import iconExit from "panorama/images/icon-exit.svg";

import LogBookPage from "./LogBookPage";
import pages from "./pages";

class LogBookContainer {
  constructor(vnode) {
    this.unredacted = this._unredacted.bind(this);
  }

  oninit() {
    let state = this;
    state.isLoaded = false;
    state.pageIndex = 0;
    state.pageReadyIndex = 0;
    // state.unredacted = []
  }

  onupdate(vnode) {
    let state = this;

    if (vnode.attrs.pageIndex !== state.pageIndex) {
      state.pageIndex = vnode.attrs.pageIndex;
      m.redraw();
    }
  }

  oncreate(vnode) {
    let state = this;
    const cover = vnode.dom.querySelector(".js-journal-cover");
    if (!cover) return;

    function loaded() {
      state.isLoaded = true;
      m.redraw();
    }

    if (cover.complete) {
      loaded(vnode);
    } else {
      cover.addEventListener("load", loaded);
      cover.addEventListener("error", function () {
        alert("error");
      });
    }

    const pg = vnode.dom.querySelectorAll(".log-book-page");
    pg.forEach((page) => {
      page.addEventListener("transitionend", () => {
        if (state.pageIndex !== state.pageReadyIndex) {
          state.pageReadyIndex = state.pageIndex;
          m.redraw();
        }
      });
    });
  }

  _unredacted(viewedOverlays = []) {
    return pages
      .map((page, index) => {
        if (viewedOverlays.indexOf(page.redactionID) !== -1) {
          return index;
        }
      })
      .filter((item) => typeof item === "number");

    // m.redraw()
  }

  view(vnode) {
    let state = this;

    // const pageIndex = vnode.attrs.pageIndex
    const open = typeof state.pageIndex === "number";

    const unr = state.unredacted(vnode.attrs.appState.viewedOverlays);

    const containerClasses = [
      "log-book-container",
      open && "is-open",
      !state.isLoaded && "is-hidden",
      state.pageIndex > 0 && "double-width",
    ]
      .filter((cl) => typeof cl === "string")
      .join(" ");

    return (
      <div className={`log-book-scrim ${open ? "is-open" : ""}`}>
        <div
          className={containerClasses}
          onclick={(e) => {
            e.stopPropagation();
            /**
             * More often than not we want to go forward through the pages.
             */
            let newIndex = state.pageIndex + 1;

            /**
             * There is one case in which we want to go back. If the book is open (double wide)
             * and the use clicks on the left half of the book. I think, using the whole
             * screen width and comparing the screenX value from the click event is the most
             * reliable cross-browser.
             */
            if (e.currentTarget.classList.contains("double-width")) {
              if (e.pageX <= window.innerWidth / 2) {
                newIndex = state.pageIndex - 1;
              }
            }

            if (newIndex >= pages.length) return false;

            vnode.attrs.toggleLogBook(newIndex);
          }}
        >
          {open && (
            <img
              className="log-book-icon is-open"
              src={iconExit}
              onclick={(e) => {
                e.stopPropagation();
                vnode.attrs.toggleLogBook(null);
              }}
            />
          )}

          {pages.map((page, index) => (
            <LogBookPage
              {...vnode.attrs}
              page={page}
              index={index}
              pageIndex={state.pageIndex}
              pageReadyIndex={state.pageReadyIndex}
              pageTotal={pages.length}
              unredacted={unr.indexOf(index) !== -1}
              // setRedaction={state._setRedaction.bind(state, vnode)}
            />
          ))}

          <div
            className={`log-book-opener ${open ? "is-hidden" : ""}`}
            onclick={() => {
              vnode.attrs.toggleLogBook(1);
            }}
          />
        </div>
      </div>
    );
  }
}

export default LogBookContainer;
